export const useNotifications = () => {
  return process.env.REACT_APP_ENABLE_NOTIFICATIONS === 'true';
};

export const isNotificationsEnabled = () => {
  return process.env.REACT_APP_ENABLE_NOTIFICATIONS === 'true';
};

export const useWireTransfer = () => {
  return process.env.REACT_APP_ENABLE_WIRE_TRANSFER === 'true';
};

export const isWireTransferEnabled = () => {
  return process.env.REACT_APP_ENABLE_WIRE_TRANSFER === 'true';
};

export const useAutoApproval = () => {
  return process.env.REACT_APP_AUTO_APPROVE_REGISTRATIONS === 'true';
};

export const isAutoApprovalEnabled = () => {
  return process.env.REACT_APP_AUTO_APPROVE_REGISTRATIONS === 'true';
};

export const useTrainerExtendedFeatures = () => {
  return process.env.REACT_APP_TRAINER_EXTENDED_FEATURES === 'true';
};

export const isTrainerExtendedFeaturesEnabled = () => {
  return process.env.REACT_APP_TRAINER_EXTENDED_FEATURES === 'true';
};